export const NATIVE_CAPABILITIES = ["read", "write", "shell"] as const;

export const EXTENSION_CAPABILITIES = ["web", "subagents"] as const;

export const CAPABILITIES = [...NATIVE_CAPABILITIES, ...EXTENSION_CAPABILITIES] as const;
export type Capability = (typeof CAPABILITIES)[number];

const KNOWN = new Set<string>(CAPABILITIES);

export function isACapability(said: unknown): said is Capability {
  return typeof said === "string" && KNOWN.has(said);
}

export function capabilitiesIn(column: unknown): Capability[] {
  const said =
    typeof column === "string"
      ? column.replace(/^{|}$/g, "").split(",")
      : Array.isArray(column)
        ? column
        : [];

  const seen = new Set(said.map((one) => (typeof one === "string" ? one.trim() : "")));
  return CAPABILITIES.filter((capability) => seen.has(capability));
}

export function whatToolsMeant(row: { tools: boolean; toolFlags?: unknown }): Capability[] {
  if (!row.tools) return [];
  return capabilitiesIn([...NATIVE_CAPABILITIES, ...capabilitiesIn(row.toolFlags)]);
}

export function capabilitiesOf(row: {
  capabilities?: unknown;
  tools: boolean;
  toolFlags?: unknown;
}): Capability[] {
  const armed = capabilitiesIn(row.capabilities);
  return armed.length > 0 ? armed : whatToolsMeant(row);
}

export function theToolsBoolean(capabilities: readonly Capability[]): boolean {
  return NATIVE_CAPABILITIES.some((native) => capabilities.includes(native));
}

export function theToolFlags(capabilities: readonly Capability[]): string[] {
  return EXTENSION_CAPABILITIES.filter((flag) => capabilities.includes(flag));
}

export function armsTheWeb(capabilities: readonly string[]): boolean {
  return capabilities.includes("web");
}
